<template>
  <transition name="widgetbutton" mode="out-in" appear>
    <slot />
  </transition>
</template>

<script setup lang="ts">

</script>

<style lang="scss">
// widgetbutton transitions

/* .fade-leave-active below version 2.1.8 */

.widgetbutton-enter-from {
  opacity: 0.2;
  transform: scale(0);
}

.widgetbutton-enter-active {
  transition: opacity 0.4s, transform 0.4s cubic-bezier(0.1, 0.8, 0.3, 1.5);
  transform-origin: 30px 30px;
}

/* .fade-leave-active below version 2.1.8 */
.widgetbutton-enter-to {
  opacity: 1;
  transform: scale(1);
}

/* .fade-leave-active below version 2.1.8 */
.widgetbutton-leave--from {
  opacity: 1;
  transform: scale(1);
}

.widgetbutton-leave-active {
  // position: absolute;
  // min-height: calc(100% - 10px);
  transition: opacity 0.25s, transform 0.5s;
  transform-origin: 50px 50px;

  @media (min-width: $kw-widget-breakpoint) {
    transform-origin: 30px 30px;
  }
}

/* .fade-leave-active below version 2.1.8 */
.widgetbutton-leave-to {
  opacity: 0;
  transform: scale(0);
}
</style>
